import { ui } from '../../styles/ui'

export default function ErrorState({ text = 'Something went wrong', action }) {
  return (
    <div className={ui.states.error} role="alert">
      <p>{text}</p>
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  )
}
